import { Flex } from '@servicetitan/anvil2';
import { SubmitApplicationDecision, FinancingApi } from '@servicetitan/financing-api-client';
import { DecisionDataStore, SecondLook } from '@servicetitan/financing-decision-shared';
import { OffersContainer, SelectedPlanStore } from '@servicetitan/financing-plans-shared';
import { FullApplicationFormDialog } from '@servicetitan/financing-application-shared';
import {
    useProviderConfig,
    useSecondLookProviderName,
} from '@servicetitan/financing-workflow-shared';
import { useEffect, useState } from 'react';
import { useDependencies } from '@servicetitan/react-ioc';

export const SecondLookDecisionWorkflow = () => {
    const { decisionData, setDecisionData } = DecisionDataStore.useStore();
    const { selectedPlan } = SelectedPlanStore.useStore();
    const [isPlanSelected, setIsPlanSelected] = useState(false);
    const [isPlanConfirmed, setIsPlanConfirmed] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showFullAppForm, setShowFullAppForm] = useState(false);
    const [financingApi] = useDependencies(FinancingApi);
    const providerConfig = useProviderConfig();
    const secondLookProviderName = useSecondLookProviderName();

    useEffect(() => {
        if (selectedPlan) {
            setIsPlanSelected(true);
        }
    }, [selectedPlan]);

    const handleConfirmOffer = async () => {
        if (!selectedPlan || !decisionData?.loanId || isSubmitting) {
            return;
        }

        setIsSubmitting(true);
        try {
            await financingApi.offersApplyForOffer(decisionData.loanId, {
                financingId: decisionData.loanId,
                offerId: selectedPlan.planNumber,
                userContext: null,
                extendedProperties: null,
            });

            setIsPlanConfirmed(true);
        } catch {
            setDecisionData({
                ...decisionData,
                decision: SubmitApplicationDecision.Error,
            });
            setIsPlanSelected(false);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (isPlanConfirmed) {
        return <SecondLook.Complete />;
    }

    const hasDeclinedAction = !!providerConfig.declinedAccessLinkLabel;

    return isPlanSelected ? (
        <SecondLook.PlanConfirmation
            onConfirm={handleConfirmOffer}
            disabled={isSubmitting}
            providerName={secondLookProviderName}
        />
    ) : decisionData?.decision === SubmitApplicationDecision.Approved ? (
        <>
            <Flex direction="column" gap="6" alignItems="center" style={{ width: '100%' }}>
                <SecondLook.Approved
                    onDeclinedLinkClick={
                        hasDeclinedAction ? () => setShowFullAppForm(true) : undefined
                    }
                />
                {decisionData.loanId && <OffersContainer loanId={decisionData.loanId} />}
            </Flex>
            {/* No confirmation dialog after submission: the user is already on the second-look
               approved screen with offers, so the WF application is secondary. */}
            <FullApplicationFormDialog
                open={showFullAppForm}
                onClose={() => setShowFullAppForm(false)}
                onApplicationOpened={() => setShowFullAppForm(false)}
            />
        </>
    ) : (
        <SecondLook.Declined />
    );
};
